import type { ReactNode } from "react";
import { ArrowLeft } from "lucide-react";
import { SongLearnCanvasBackdrop } from "../SongLearnCanvasBackdrop";
import { cn } from "../../lib/utils";

export interface ModuleStudioShellProps {
  title: string;
  subtitle?: string;
  onBack: () => void;
  backLabel?: string;
  accent: string;
  border: string;
  textMain: string;
  textMuted: string;
  textDim: string;
  headerExtra?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function ModuleStudioShell({
  title,
  subtitle,
  onBack,
  backLabel = "Volver al hub",
  accent,
  border,
  textMain,
  textMuted,
  textDim,
  headerExtra,
  children,
  className,
}: ModuleStudioShellProps) {
  const glassPanel =
    "border border-white/[0.08] bg-black/30 shadow-[0_8px_32px_rgba(0,0,0,0.35)]";

  return (
    <SongLearnCanvasBackdrop ambient="lite" className={cn("h-full min-h-0 flex-1", className)}>
      <div className="h-full flex flex-col min-h-0 font-sans" style={{ color: textMain }}>
        <header
          className={cn("shrink-0 px-4 sm:px-6 py-3 flex items-center justify-between gap-3", glassPanel)}
        >
          <div className="flex items-center gap-3 min-w-0">
            <button
              type="button"
              onClick={onBack}
              className="shrink-0 w-9 h-9 rounded-lg flex items-center justify-center transition-colors hover:bg-white/5"
              style={{ border: `1px solid ${border}`, color: textMuted }}
              aria-label={backLabel}
            >
              <ArrowLeft className="w-4 h-4" />
            </button>
            <div className="min-w-0">
              <h1 className="text-sm sm:text-base font-bold truncate">{title}</h1>
              {subtitle && (
                <p className="text-[11px] truncate" style={{ color: textDim }}>
                  {subtitle}
                </p>
              )}
            </div>
          </div>
          {headerExtra}
        </header>

        <div className="flex-1 min-h-0 flex flex-col overflow-hidden relative mx-4 sm:mx-6 mt-2 mb-2">
          {children}
        </div>
      </div>
    </SongLearnCanvasBackdrop>
  );
}
